import { render, staticRenderFns } from "./print-media-list.vue?vue&type=template&id=0236f290&scoped=true"
import script from "./print-media-list.vue?vue&type=script&lang=ts"
export * from "./print-media-list.vue?vue&type=script&lang=ts"
import style0 from "./print-media-list.vue?vue&type=style&index=0&id=0236f290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236f290",
  null
  
)

export default component.exports